import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "area";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    provinces: []
  },
  actions: {
    //获取经销商列表;
    async getProvinces({ commit, state }) {
      if (state.provinces.length !== 0) return;
      let result = await api.get(`/api/Area?parentNo=0`);
      commit("setProvinces", result.data);
    },
    async getArea({ commit }, payload) {
      // 获取省份
      let result = await api.get(`/api/Area?${queryString.stringify(payload)}`);
      return result.data;
    }
  },
  mutations: {
    setProvinces(state, payload) {
      state.provinces = payload;
    }
  }
});

export default moduleName;
